module.exports = __webpack_public_path__ + "assets/img/lphone.f9d145a9.png";